// NEW_FILE_JUSTIFIED: extracted from ExtractPolicyPage.tsx to keep that file under the 200-line cap
import { Sparkles, ShieldCheck } from 'lucide-react';
import { Card } from '@/components/ui/card';

export function ExtractInfoRail() {
  return (
    <aside className="space-y-4">
      <Card className="p-5 space-y-3">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-primary" aria-hidden="true" />
          <h2 className="text-sm font-semibold">How AI extraction works</h2>
        </div>
        <ol className="space-y-2 text-sm text-muted-foreground">
          <li>
            <span className="font-medium text-foreground">1. Upload</span> a PDF, photo, or scan of
            an existing policy.
          </li>
          <li>
            <span className="font-medium text-foreground">2. Detect</span> sections &amp; fields —
            AI proposes a builder-ready structure.
          </li>
          <li>
            <span className="font-medium text-foreground">3. Review &amp; refine</span> — edit,
            remove, or add anything before saving.
          </li>
        </ol>
      </Card>
      <Card className="p-5 space-y-2">
        <div className="flex items-center gap-2">
          <ShieldCheck className="h-4 w-4 text-primary" aria-hidden="true" />
          <h2 className="text-sm font-semibold">Your data stays private</h2>
        </div>
        <p className="text-xs text-muted-foreground">
          Files are deleted after extraction. We never train models on your documents.
        </p>
      </Card>
    </aside>
  );
}
